// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txt-width {
   width: 70%;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

.member-group {
   display: inline-block;
   white-space: nowrap;
   overflow: hidden !important;
   text-overflow: ellipsis;
}

.member-group-email {
   white-space: nowrap;
   overflow: hidden !important;
   text-overflow: ellipsis;
}

.error {
   color: red;
   font-size: 12px;
   margin-top: -10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/contact/new-group/new-group.component.css"],"names":[],"mappings":"AAAA;GACG,UAAU;AACb;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,qBAAqB;GACrB,mBAAmB;GACnB,2BAA2B;GAC3B,uBAAuB;AAC1B;;AAEA;GACG,mBAAmB;GACnB,2BAA2B;GAC3B,uBAAuB;AAC1B;;AAEA;GACG,UAAU;GACV,eAAe;GACf,iBAAiB;AACpB","sourcesContent":[".txt-width {\n   width: 70%;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n.member-group {\n   display: inline-block;\n   white-space: nowrap;\n   overflow: hidden !important;\n   text-overflow: ellipsis;\n}\n\n.member-group-email {\n   white-space: nowrap;\n   overflow: hidden !important;\n   text-overflow: ellipsis;\n}\n\n.error {\n   color: red;\n   font-size: 12px;\n   margin-top: -10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
